import { render, staticRenderFns } from "./networking.k8s.io.ingress.vue?vue&type=template&id=0cd89716&"
import script from "./networking.k8s.io.ingress.vue?vue&type=script&lang=js&"
export * from "./networking.k8s.io.ingress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports